export const getQuestionId = ({ qaReducer: { questionDetails } }) => questionDetails.id;
